<template>
<div class="chat abspage nohpage3">

	<maincontent>
		<template v-slot:content>
			<joined :id="id"/>
		</template>
	</maincontent>

</div>
</template>

<style scoped lang="sass">

</style>

<script>
import joined from "@/components/modules/courses/joined/index.vue";



export default {
	name: 'course_joined_page',
	components: {
        joined
	},

	computed: {
        id : function(){
            return this.$route.params.id
        }
	},

	methods: {

	},

	mounted() {

	}
}
</script>
